import { UserSubscriptionStatus } from "../../../../enums";

export enum OrderType {
  ORDER = "order",
  SWITCH = "switch",
  CANCEL_SWITCH = "cancel_switch",
  CANCEL_SUB = "cancel_sub",
  CANCEL_SUB_IN_SWITCH = "cancel_sub_in_switch",
  UNCANCEL_SUB = "uncancel_sub",
  PAYMENT_DETAILS = "payment_details",
  PAUSE_SUB = "pause_sub",
  UNPAUSE_SUB = "unpause_sub",
}

export enum OrderStatus {
  DRAFT = "draft",
  PENDING = "pending",
  OTHER_ERROR = "other_error",
  PAYMENT_CANCEL = "payment_cancel",
  PAYMENT_ERROR = "payment_error",
  COMPLETED = "completed",
}

export enum RedbeeStatus {
  DRAFT = "draft",
  PENDING = "pending",
  ERROR = "error",
  COMPLETED = "completed",
}

export enum AgillicStatus {
  DRAFT = "draft",
  PENDING = "pending",
  ERROR = "error",
  COMPLETED = "completed",
}

export interface IOrderStatusResponseModel {
  error?: {
    message: string;
    stack: Record<string, string> | null;
  };
  order: {
    type: OrderType;
    status: OrderStatus;
    redbee_status: RedbeeStatus;
    agillic_status: AgillicStatus;
    created_at: string;
    updated_at: string;
  };
  subscription: {
    id: number;
    status: UserSubscriptionStatus;
  } | null;
  reepay_payment_method?: {
    id: string;
    payment_type: "card"; // For now it is the only available payment method
    card: {
      card_type: string;
      masked_card: string;
      exp_date: string;
    };
  };
}
